<div style={customStyle}>
  <Components.TextDisplay {className} text={fields.text[0] || {}} />
</div>

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const classNames = ['plugin__text']

  export const Components = {
    load: [
      'core/extensions/text_display/v1.0.0/TextDisplay',
    ],
  }

  export const listeners = [{
    event: 'mode.edit',
    async handler ({ platform }) {
      await platform.api.core.loadComponents(
        ['legacy/plugins/text/v1.0.0/EditInline', 'core/extensions/rte/v1.0.0/RTE'],
        { noMissing: true },
      )
    },
  }]
</script>

<script>
  export let fields = {}
  export let className = null

  const customStyle = `
    ${fields.backgroundColour ? `background-color: ${fields.backgroundColour};` : ''}
    ${fields.fontColour ? `color: ${fields.fontColour};` : ''}
    ${fields.padding ? `padding: ${fields.padding}px;` : ''}
  `

  $: if (!fields.text) {
    fields.text = [{ data: '<p>Click here to edit this text.</p>', type: 'html' }]
  }
</script>
